/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseErrorForbiddenAllOfError
 */
export interface ResponseErrorForbiddenAllOfError {
    /**
     * 
     * @type {string}
     * @memberof ResponseErrorForbiddenAllOfError
     */
    code: ResponseErrorForbiddenAllOfErrorCodeEnum;
}


/**
 * @export
 */
export const ResponseErrorForbiddenAllOfErrorCodeEnum = {
    Forbidden: 'forbidden'
} as const;
export type ResponseErrorForbiddenAllOfErrorCodeEnum = typeof ResponseErrorForbiddenAllOfErrorCodeEnum[keyof typeof ResponseErrorForbiddenAllOfErrorCodeEnum];


/**
 * Check if a given object implements the ResponseErrorForbiddenAllOfError interface.
 */
export function instanceOfResponseErrorForbiddenAllOfError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function ResponseErrorForbiddenAllOfErrorFromJSON(json: any): ResponseErrorForbiddenAllOfError {
    return ResponseErrorForbiddenAllOfErrorFromJSONTyped(json, false);
}

export function ResponseErrorForbiddenAllOfErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseErrorForbiddenAllOfError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function ResponseErrorForbiddenAllOfErrorToJSON(value?: ResponseErrorForbiddenAllOfError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}

